import { rootModuleId } from "@app/const";
import { ObjectClass } from "@app/types";

/**
 * Wizard Class manages instantiating and potetntially modifying wizards
 * Initial implementation covers Common Modules and their wizard configs
 */
export default class WizardConfig{

    // initialize and update wizard config
    // definition of wizard config data
    getConfig(serialized){
        const wizardConfig = serialized.wizardConfig || {};
        const inputType = this.getInputType(serialized);
        const expectedIntent = this.getExpectedIntent(serialized);
        const configMap = {
            initialPrompt: wizardConfig['initialPrompt'] || '',
            invalidPrompt: wizardConfig['invalidPrompt'] || '',
            rePrompt: wizardConfig['rePrompt'] || '',
            confirmPrompt: wizardConfig['confirmPrompt'] || '',    
            inputType: wizardConfig['inputType'] || inputType || '',
            expectedIntent: wizardConfig['expectedIntent'] || expectedIntent || '',
            moduleInputs: []
        }

        return configMap;

    }
    getInputType(serialized) {
        const rootModule = serialized.components.modules.find(m => m.id === rootModuleId);
        // TODO: test for more than one input in rootModule?
        const inputType= rootModule.versions[1].flow.nodes.find(n => n._class === ObjectClass.input);
        if(inputType){
            return inputType.props.config.inputType;
        }
       
    }
    getExpectedIntent(serialized) {
        // TODO: test for more than one input in rootModule?
        const rootModule = serialized.components.modules.find(m => m.id === rootModuleId);
        const expectedIntent = rootModule.versions[1].flow.nodes.find(n => n._class === ObjectClass.input);
        if(expectedIntent){
            return expectedIntent.props.config.expectedIntent;
        }
       
    }
}